module.exports = __webpack_public_path__ + "img/en.98fe9f0d.png";